export default "__VITE_ASSET__CvsuWE4H__"